import { useApp } from "../hooks/useApp";
import { ActivePendants } from "./all/ActivePendants/ActivePendants";
import { Pendants } from "./all/Pendants/Pendants";
import { ActiveProductVariantDescription } from "./all/ActiveProductVariantDescription/ActiveProductVariantDescription";
import { CartBar } from "./all/CartBar/CartBar";
import { Preview } from "./all/Preview/Preview";
import { DesignSummaryPopup } from "./all/DesignSummaryPopup/DesignSummaryPopup";
import { PendantsTabs } from "./all/PendantsTabs/PendantsTabs";
import { Header } from "./all/Header/Header";
import { ChainVariants } from "./all/ChainVariants/ChainVariants";
import classNames from "classnames";
import { ConfirmationPopup } from "./all/ConfirmationPopup/ConfirmationPopup";
import { MetalToggler } from "./all/MetalToggler/MetalToggler";

export const App = () => {
  const { mainProduct, activeScreen } = useApp()

  return (
    <>
      <section className="xl-max:relative xl:grid xl:grid-cols-2 xl:gap-5 xl:min-h-screen xl:p-5">
        <div className="rounded-sm xl-max:overflow-hidden">
          <Preview className={classNames(
            "builder-preview w-full h-auto aspect-square bg-[#f8f7f5] xl-max:transform  xl:sticky xl:top-20 xl:bg-[#f2f1ed] xl-max:scale-[1.2]",
            {
              'xl-max:translate-y-[10%]': mainProduct.metafields.type === 'Necklace',
              'xl-max:translate-y-[5%]': mainProduct.metafields.type === 'Bracelet'
            } 
          )} />
        </div>

        <div className="builder-info px-5 xl:pt-[60px] xl:px-[120px]">
          <Header />

          <div className="relative xl-max:-mt-10">
            {activeScreen === 'CHAIN' && (
              <>
                <ChainVariants className="mt-5" />
                <MetalToggler className="mt-5" />
              </>
            )}
            {activeScreen === 'PENDANTS' && (
              <>
                <ActivePendants className="mt-4 xl:mt-8" /> 
                {mainProduct.metafields.pendantProducts.length > 1 && <PendantsTabs className="mt-4 xl:mt-7" />}
                <Pendants className="mt-4 xl:mt-9" />
              </>
            )}
          </div>

          <ActiveProductVariantDescription className="mt-5 xl:mt-10" />
          <CartBar className="fixed left-5 right-5 z-[1] bottom-5 xl:static xl:mt-10" />
        </div>
      </section>

      <DesignSummaryPopup/>
      <ConfirmationPopup />
    </>
  )
}
